import { FC } from "react";
import { ButtonProps, Drawer, DrawerProps, Create, FormProps, Grid } from "@pankod/refine-antd";
import { useTranslate } from "@pankod/refine-core";

import { CreateEditForm } from "./createEditForm";

interface Props {
  drawerProps: DrawerProps;
  formProps: FormProps;
  saveButtonProps: ButtonProps;
  setShopCategories: (categories: number[]) => void;
  tenantId: number | undefined;
}

export const CreateShop: FC<Props> = props => {
  const { drawerProps, formProps, saveButtonProps, setShopCategories, tenantId } = props;
  const breakpoint = Grid.useBreakpoint();
  const t = useTranslate();

  return (
    <Drawer
      {...drawerProps}
      width={breakpoint.sm ? "500px" : "100%"}
      bodyStyle={{ padding: 0 }}
      zIndex={1001}
      title={t("shops.titles.create")}
      destroyOnClose
      forceRender
    >
      <Create
        resource="shops"
        headerProps={{ extra: null }}
        goBack={null}
        breadcrumb={false}
        title={false}
        saveButtonProps={saveButtonProps}
      >
        <CreateEditForm
          formProps={formProps}
          isEdit={false}
          setShopCategories={(data: number[]) => setShopCategories(data)}
          tenantId={tenantId}
        />
      </Create>
    </Drawer>
  );
};
